import { Modal } from '@fasstech/middle-design-system';
import PropTypes from 'prop-types';

/**
 * Used if the motor does not get pricings
 */
const UnavailablePricingModal = ({
  isDisplayed = true,
  onClose,
  getMiddleText,
  textKey
}) => (
  <Modal
    isDisplayed={isDisplayed}
    button1Label={'OK'}
    onClose={onClose}
    onClick1={onClose}
  >
    <div className={'flex flex-col items-center gap-4 text-center'}>
      <p>
        {getMiddleText(
          textKey,
          {},
          'La tarification ne peut pas être calculée avec les informations saisies.'
        )}
      </p>
    </div>
  </Modal>
);

UnavailablePricingModal.propTypes = {
  isDisplayed: PropTypes.bool,
  onClose: PropTypes.func,
  getMiddleText: PropTypes.func,
  textKey: PropTypes.string
};

export default UnavailablePricingModal;
